import React, { useState } from "react";
import { Button } from "@mui/material";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";

export default function CopyURLButton() {
   const [copied, setCopied] = useState(false);

   const handleCopy = () => {
      const url = window.location.href;
      navigator.clipboard.writeText(url).then(() => {
         setCopied(true);
         setTimeout(() => setCopied(false), 2000);
      }).catch(err => {
         console.error('Failed to copy URL:', err);
         // Fallback for older browsers
         const textArea = document.createElement('textarea');
         textArea.value = url;
         document.body.appendChild(textArea);
         textArea.select();
         try {
            document.execCommand('copy');
            setCopied(true);
            setTimeout(() => setCopied(false), 2000);
         } catch (err) {
            console.error('Fallback copy failed:', err);
         }
         document.body.removeChild(textArea);
      });
   };

   return (
      <Button
         variant="outlined"
         size="small"
         onClick={handleCopy}
         startIcon={<ContentCopyIcon />}
         sx={{ ml: 2 }}
      >
         {copied ? "Copied!" : "Copy URL"}
      </Button>
   );
}
